import React from "react";
import { Star } from "lucide-react";

/**
 * Renders a 1-5 star rating. Half-star support via floor + fractional overlay.
 * If `interactive` is true, `onChange(rating)` is called on click.
 */
export default function RatingStars({
  value = 0,
  count = null,
  size = "md",
  interactive = false,
  onChange = null,
  showCount = true,
  className = "",
}) {
  const sizes = {
    xs: "w-3 h-3", sm: "w-3.5 h-3.5", md: "w-4 h-4",
    lg: "w-5 h-5", xl: "w-6 h-6", "2xl": "w-8 h-8",
  };
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid="rating-stars">
      <div className="flex items-center gap-0.5">
        {stars.map((n) => {
          const filled = value >= n;
          const half = !filled && value + 0.5 >= n;
          const StarIcon = (
            <span className={`relative inline-block ${sizes[size]}`}>
              <Star className={`${sizes[size]} ${filled ? "text-[#F26A21] fill-[#F26A21]" : "text-white/25"}`} />
              {half && (
                <span className="absolute inset-0 overflow-hidden" style={{ width: "50%" }}>
                  <Star className={`${sizes[size]} text-[#F26A21] fill-[#F26A21]`} />
                </span>
              )}
            </span>
          );
          if (!interactive) return <React.Fragment key={n}>{StarIcon}</React.Fragment>;
          return (
            <button key={n} type="button"
                    data-testid={`rating-star-${n}`}
                    onClick={() => onChange && onChange(n)}
                    className="inline-block hover:scale-110 transition-transform">
              {StarIcon}
            </button>
          );
        })}
      </div>
      {showCount && value > 0 && (
        <span className="text-xs text-gray-400">
          {typeof value === "number" ? value.toFixed(1) : value}
          {typeof count === "number" && ` · ${count}`}
        </span>
      )}
    </div>
  );
}
